(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["brinde-checkout-blocker"] && !Shopify.designMode) return;
  try {
    (function() {
  const originalButtonText = 'Finalizar a compra';
  const disabledButtonText = 'Primeiro escolha o brinde';
  
  function disableCheckout() {
    const checkoutButton = document.getElementById('checkout');
    if (!checkoutButton) return;
    checkoutButton.disabled = true;
    checkoutButton.textContent = disabledButtonText;
  }
  
  function enableCheckout() {
    const checkoutButton = document.getElementById('checkout');
    if (!checkoutButton) return;
    checkoutButton.disabled = false;
    checkoutButton.textContent = originalButtonText;
  }
  
  function checkInitialState() {
    const container = document.querySelector('.tl-custom-cart-goal-container');
    
    if (!container) {
      enableCheckout();
      return;
    }
    
    const giftNotis = container.querySelectorAll('.tl__cart-goal__gift-noti');
    
    if (giftNotis.length === 0) {
      enableCheckout();
      return;
    }
    
    let hasUnselectedGift = false;
    
    giftNotis.forEach(function(giftNoti) {
      const pointerEvents = giftNoti.style.pointerEvents || '';
      const spanText = (giftNoti.textContent || '').trim().toLowerCase();
      
      const isSelected = pointerEvents === 'none' || spanText.includes('escolhida');
      
      if (!isSelected) {
        hasUnselectedGift = true;
        
        // Add click listener to enable checkout when clicked
        giftNoti.addEventListener('click', function() {
          enableCheckout();
        });
      }
    });
    
    if (hasUnselectedGift) {
      disableCheckout();
    } else {
      enableCheckout();
    }
  }
  
  function waitForContainer() {
    const container = document.querySelector('.tl-custom-cart-goal-container');
    
    if (container) {
      checkInitialState();
    } else {
      if (waitForContainer.attempts < 20) {
        waitForContainer.attempts++;
        setTimeout(waitForContainer, 500);
      }
    }
  }
  waitForContainer.attempts = 0;
  
  window.addEventListener('load', function() {
    setTimeout(waitForContainer, 1000);
  });
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["card-product"] && !Shopify.designMode) return;
  try {
    function updateCountdown(countdownElement, date_end) {
    if (countdownElement) {
      setInterval(() => {
        const currentTime = new Date().getTime();
        const timeLeft = date_end - currentTime;

        if (timeLeft < 0) return (countdownElement.textContent = `Essa oferta terminou`);
        const days = Math.floor(timeLeft / (1000 * 60 * 60 * 24));
        const hours = Math.floor((timeLeft % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
        const minutes = Math.floor((timeLeft % (1000 * 60 * 60)) / (1000 * 60));
        const seconds = Math.floor((timeLeft % (1000 * 60)) / 1000);

        if (days <= 0) {
          countdownElement.textContent = `Termina em ${hours.toString().padStart(2, '0')}:${minutes
            .toString()
            .padStart(2, '0')}:${seconds.toString().padStart(2, '0')}`;
        } else {
          countdownElement.textContent = `Termina em ${days} dias ${hours.toString().padStart(2, '0')}:${minutes
            .toString()
            .padStart(2, '0')}:${seconds.toString().padStart(2, '0')}`;
        }
      }, 1000);
    }
  }

  addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll('.red-count').forEach((el) => {
      el.style.display = '';
      updateCountdown(el, el.dataset.date);
    });
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["cart-recomendations"] && !Shopify.designMode) return;
  try {
    document.querySelectorAll('.product-bundle-container').forEach((container) => {
    const slides = container.querySelectorAll('.product-bundle');
    const btnLeft = container.querySelector('.carousel-btn-left');
    const btnRight = container.querySelector('.carousel-btn-right');
    const totalSlides = slides.length;
    let currentSlide = 0;
    let autoRotateInterval;

    if (totalSlides <= 1) {
      if (btnLeft) btnLeft.style.display = 'none';
      if (btnRight) btnRight.style.display = 'none';
      return;
    }

    function showSlide(index) {
      slides.forEach((slide) => {
        slide.classList.remove('active');
      });
      slides[index].classList.add('active');
      currentSlide = index;
    }

    function nextSlide() {
      const next = (currentSlide + 1) % totalSlides;
      showSlide(next);
    }

    function prevSlide() {
      const prev = (currentSlide - 1 + totalSlides) % totalSlides;
      showSlide(prev);
    }

    function startAutoRotate() {
      autoRotateInterval = setInterval(nextSlide, 5000);
    }

    function stopAutoRotate() {
      clearInterval(autoRotateInterval);
    }

    if (btnLeft) {
      btnLeft.addEventListener('click', () => {
        stopAutoRotate();
        prevSlide();
        startAutoRotate();
      });
    }

    if (btnRight) {
      btnRight.addEventListener('click', () => {
        stopAutoRotate();
        nextSlide();
        startAutoRotate();
      });
    }

    startAutoRotate();

    document.addEventListener('DOMContentLoaded', () => {
      container.addEventListener('mouseenter', stopAutoRotate);
      container.addEventListener('mouseleave', startAutoRotate);
    });
  });

  document.addEventListener('DOMContentLoaded', function () {
    const storedScrollPosition = localStorage.getItem('scrollPosition');

    if (storedScrollPosition) {
      window.scrollTo({
        top: parseInt(storedScrollPosition),
        left: 0,
        behavior: 'smooth',
      });
      localStorage.removeItem('scrollPosition');
    }

    document.querySelectorAll('.cart-button[data-product-id]').forEach((button) => {
      button.addEventListener('click', function () {
        const productId = this.getAttribute('data-product-id');
        const icon = this.querySelector('i');
        const spinner = this.querySelector('.loading__spinner');

        icon.style.display = 'none';
        spinner.classList.remove('hidden');

        fetch('/cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({
            items: [
              {
                id: productId,
                quantity: 1,
              },
            ],
          }),
        })
          .then((response) => response.json())
          .then((data) => {
            icon.style.display = 'flex';
            spinner.classList.add('hidden');
            localStorage.setItem('scrollPosition', window.scrollY);
            window.location.reload(true);
          })
          .catch((error) => console.error('Error:', error));
      });
    });
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["product-recomendations"] && !Shopify.designMode) return;
  try {
    const update_cart_quantity = (quantity) => {
    let cartQuantity = document.querySelector('.cart-count-bubble > span');
    let cartMessage = document.querySelector('.cart-message');

    if (!cartQuantity) {
      let svg_wrapper = document.querySelector('#cart-icon-bubble > .svg-wrapper');

      let cartQuantityElement = `
        <div class="cart-count-bubble">
          <span aria-hidden="true">1</span>
          <span class="visually-hidden">1 item</span>
        </div>
      `;

      svg_wrapper.insertAdjacentHTML('beforeend', cartQuantityElement);
    }

    if (cartQuantity) {
      cartQuantity.innerText = parseInt(cartQuantity.innerText) + quantity;
    }

    if (cartMessage) {
      cartMessage.innerHTML = '*Adicionado ao carrinho! <a href="/cart">Ver carrinho</a>';
    }
  };

  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('.cart-button[data-product-id]').forEach((button) => {
      button.addEventListener('click', function () {
        const productId = this.getAttribute('data-product-id');
        const icon = this.querySelector('i');
        const spinner = this.querySelector('.loading__spinner');

        icon.style.display = 'none';
        spinner.classList.remove('hidden');

        fetch('/cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({
            items: [
              {
                id: productId,
                quantity: 1,
              },
            ],
          }),
        })
          .then((response) => response.json())
          .then((data) => {
            icon.style.display = 'flex';
            spinner.classList.add('hidden');
            update_cart_quantity(1);
          })
          .catch((error) => console.error('Error:', error));
      });
    });

    document.querySelector('.add-all-button')?.addEventListener('click', function () {
      const productItems = document.querySelectorAll('.cart-button[data-product-id]');
      let btn_text = this.querySelector('.button__text');
      let btn_load = this.querySelector('.loading__spinner');

      btn_text.innerText = '';
      btn_load.classList.remove('hidden');

      const items = Array.from(productItems).map((button) => ({
        id: button.getAttribute('data-product-id'),
        quantity: 1,
      }));

      fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ items }),
      })
        .then((response) => response.json())
        .then((data) => {
          update_cart_quantity(data.items.length);
          btn_text.innerText = 'Adicionar tudo ao carrinho novamente';
          btn_load.classList.add('hidden');
        })
        .catch((error) => console.error('Error:', error));
    });
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["product-stories"] && !Shopify.designMode) return;
  try {
    document.addEventListener('DOMContentLoaded', function () {
    const modalHTML = `
    <div id="stories-modal" class="stories-modal">
        <div class="stories-modal-content">
            <span class="stories-modal-close"><i class="ph ph-x-circle"></i></span>
            <div id="stories-modal-body"></div>
        </div>
    </div>
`;
    document.body.insertAdjacentHTML('beforeend', modalHTML);

    const items = document.querySelectorAll('.stories-item');
    const modal = document.getElementById('stories-modal');
    const modalBody = document.getElementById('stories-modal-body');
    const closeBtn = document.querySelector('.stories-modal-close');

    items.forEach((item, index) => {
      item.addEventListener('click', () => {
        const videoElement = item.querySelector('video, iframe');
        if (!videoElement) return;

        const clone = videoElement.cloneNode(true);
        if (clone.tagName.toLowerCase() === 'video') {
          clone.removeAttribute('muted');
          clone.setAttribute('controls', 'true');
          clone.setAttribute('disablePictureInPicture', 'true');
          clone.setAttribute('controlslist', 'nodownload nofullscreen noremoteplayback noplaybackrate');
          clone.setAttribute('autoplay', 'true');
        }

        modalBody.innerHTML = '';
        modalBody.appendChild(clone);
        modal.style.display = 'flex';
        document.body.style.overflow = 'hidden';

        if (typeof posthog !== 'undefined' && typeof posthog.capture === 'function') {
          const wrapper = item.closest('.stories-wrapper');
          posthog.capture('product_story_opened', {
            product_id: wrapper && wrapper.dataset.productId,
            product_handle: wrapper && wrapper.dataset.productHandle,
            story_index: index
          });
        }
      });
    });

    closeBtn.addEventListener('click', () => {
      modal.style.display = 'none';
      modalBody.innerHTML = '';
      document.body.style.overflow = 'auto';
    });

    modal.addEventListener('click', (e) => {
      if (e.target === modal) {
        modal.style.display = 'none';
        modalBody.innerHTML = '';
        document.body.style.overflow = 'auto';
      }
    });

    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && modal.style.display === 'flex') {
        modal.style.display = 'none';
        modalBody.innerHTML = '';
        document.body.style.overflow = 'auto';
      }
    });
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["product-videos"] && !Shopify.designMode) return;
  try {
    document.addEventListener('DOMContentLoaded', function () {
    const modalHTML = `
    <div id="video-modal" class="video-modal">
        <div class="video-modal-content">
            <span class="video-modal-close"><i class="ph ph-x-circle"></i></span>
            <div id="video-modal-body"></div>
        </div>
    </div>
`;
    document.body.insertAdjacentHTML('beforeend', modalHTML);

    const items = document.querySelectorAll('.video-item');
    const modal = document.getElementById('video-modal');
    const modalBody = document.getElementById('video-modal-body');
    const closeBtn = document.querySelector('.video-modal-close');

    items.forEach((item, index) => {
      item.addEventListener('click', () => {
        const videoElement = item.querySelector('video, iframe');
        if (!videoElement) return;

        const clone = videoElement.cloneNode(true);
        if (clone.tagName.toLowerCase() === 'video') {
          clone.removeAttribute('muted');
          clone.setAttribute('controls', 'true');
          clone.setAttribute('disablePictureInPicture', 'true');
          clone.setAttribute('controlslist', 'nodownload nofullscreen noremoteplayback noplaybackrate');
          clone.setAttribute('autoplay', 'true');
        }

        modalBody.innerHTML = '';
        modalBody.appendChild(clone);
        modal.style.display = 'flex';
        document.body.style.overflow = 'hidden';
      });
    });

    closeBtn.addEventListener('click', () => {
      modal.style.display = 'none';
      modalBody.innerHTML = '';
      document.body.style.overflow = 'auto';
    });

    modal.addEventListener('click', (e) => {
      if (e.target === modal) {
        modal.style.display = 'none';
        modalBody.innerHTML = '';
        document.body.style.overflow = 'auto';
      }
    });

    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && modal.style.display === 'flex') {
        modal.style.display = 'none';
        modalBody.innerHTML = '';
        document.body.style.overflow = 'auto';
      }
    });
  });
  } catch(e) { console.error(e); }
})();

})();
